// extracted by mini-css-extract-plugin
export default {"name_input":"ParentCompanyForm_name_input__QYAYd","image_title":"ParentCompanyForm_image_title__J7X00"};